import React, {Component} from "react";

class CommonHeader extends Component {

    render() {
        const {className, headerTitle, buttonTitle, buttonAction} = this.props;

        return (
            <div className={className}>
                <label>{ headerTitle }</label>
                {
                    buttonTitle && <button className="btn btn-info btn-sm float-sm-right" onClick={ buttonAction }>{ buttonTitle }</button>
                    
                }
            </div>
                
        );
    }
}

export default CommonHeader;